import { CSSProperties, FC } from "react";
import { useTranslation } from "react-i18next";
import { useLoaderData } from "@remix-run/react";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import styles from "./terms-and-conditions.module.css";
import Breadcrumbs from "~/components/breadcrumbs/breadcrumbs";
import TermsItem from "../../components/terms-item";
import { TermsAndConditionsResponse } from "../../entities/terms-and-conditions.entities";

interface TermsAndConditionsProps {}

const TermsAndConditions: FC<TermsAndConditionsProps> = () => {
  const { t } = useTranslation();
  const { theme } = useGlobalStyles();
  const { data } = useLoaderData<{data: TermsAndConditionsResponse;}>();

  return (
    <div className={styles.wrapper}>
      <div className={styles.mainContent}>
        <Breadcrumbs routes={[{ text: "Términos y condiciones" }]} />
        <h4
          className={styles.mainTitle}
          style={({ "--color": theme.themeColors.button } as CSSProperties)}>

          {t("termsAndConditions.title")}
        </h4>
        {data?.termGroups?.map((termGroup) =>
        <div className={styles.termsItem}>
            <div className={styles.name}>{termGroup.title}</div>
            {termGroup.questions.map((subTermGroup) =>
          <TermsItem className={styles.group} subTermGroup={subTermGroup} />
          )}
          </div>
        )}
      </div>
    </div>);

};

export default TermsAndConditions;